<template>
    <div class="user-details" v-if="user">
        <b-badge :id="popoverId" variant="dark" style="color: white; margin:5px">
            {{ user.full_name }}
        </b-badge>
        <b-popover :target="popoverId" triggers="hover" placement="left">
            <template #title><h4 class="mb-0">{{ user.full_name }}</h4></template>
            <template v-if="companyNames.length"><strong>{{ companyNames.length > 1 ? 'Companies' : 'Company' }}:</strong> {{ formatNames(companyNames) }}<br></template>
            <template v-if="agencyNames.length"><strong>{{ agencyNames.length > 1 ? 'Agencies' : 'Agency' }}:</strong> {{ formatNames(agencyNames) }}<br></template>
            <strong>Email:</strong> {{ user.email }}<br>
            <template v-if="user.phone_mobile"><strong>Mobile:</strong> {{ user.phone_mobile }}<br></template>
            <template v-if="user.phone_office"><strong>Office:</strong> {{ user.phone_office }}<br></template>
            <b-btn v-if="!user.disabled" @click="showModal()" variant="success">
                Send Message
                <b-icon-box-arrow-right/>
            </b-btn>
        </b-popover>

        <message-create-modal :modalId="modalId" :recipient="this.user"/>
    </div>
</template>

<script>

import MessageCreateModal from './MessageCreateModal'
import * as _ from 'lodash'

/**
 * A badge with the user name and contact info on hover
 */
export default {
    name: 'UserDetails',
    components: { MessageCreateModal },
    props: {
        user: Object,
    },
    data () {
        return {
            agency: null,
        }
    },
    methods: {
        showModal () {
            this.$bvModal.show(this.modalId)
        },
        formatNames (names) {
            return names ? _.truncate(names.join(', ')) : null
        }
    },
    computed: {
        hash () {
            return Math.random().toString(36).substr(2, 5)
        },
        popoverId () {
            return 'popover' + this.hash
        },
        modalId () {
            return 'message_modal' + this.hash
        },
        companyNames () {
            return this.user.companies.map(c => c.name).sort()
        },
        agencyNames () {
            return this.user.agencies.map(a => a.name).sort()
        },
    },
}
</script>

<style>

</style>
